export default "__VITE_ASSET__c171150c__"